<!--
Author: TangChen
Date: 2018-09-19
Desc: 协议内容
-->
<template>
    <div class="comp-agreement comp">
        <!--<el-checkbox name="type">
            <div class="agree-list clear">
                <b>我已阅读并同意</b>
                <span v-for="item of protocol" :key="item.id" v-on:click.prevent="agreementCon(item)">《{{ item.title }}》</span>
            </div>
        </el-checkbox>-->
        <el-dialog
            :title="agrCon.title"
            :visible.sync="centerDialogVisible"
            :fullscreen="isFullscreen"
            max-height="80%"
        >
            <div v-if="agrCon.content" v-html="agrCon.content" />
            <div
                v-else-if="filePath"
                v-loading="fileLoading"
                style="justify-content: center; display: flex"
            >
                <iframe
                    ref="iframe"
                    style="width: 800px; height: 400px; border: none"
                    :src="filePath"
                    v-on:load="onLoad"
                ></iframe>
            </div>
            <div slot="footer" class="dialog-footer align-c">
                <el-button type="primary" v-on:click="confirmCon">我已知晓</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import userApi from "@/api/user";
const fileUrl = "/js/pdfjs/web/viewer.html";

export default {
    name: "Agreement",
    props: {
        data: {
            type: String,
            required: true
        },
        value: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            protocol: [],
            centerDialogVisible: false,
            agrCon: {},
            isFullscreen: false,
            index: 0,
            filePath: "",
            fileLoading: false
        };
    },
    watch: {
        value(val) {
            if (val) {
                if (this.protocol.length === this.index && this.index > 0) {
                    this.$emit("all-read", true);
                    return;
                }
                this.getAgreement();
            }
        },
        centerDialogVisible(val) {
            if (!val) {
                this.$emit("all-read", false);
            }
        }
    },
    mounted() {},
    methods: {
        handlePdfUrlChange(val) {
            if (val) {
                this.fileLoading = true;
                console.log("handlePdfUrlChange", val);
                const fileGet = this.$util.fileDownloadPath(val);
                this.filePath =
                    fileUrl +
                    "?file=" +
                    encodeURIComponent(fileGet) +
                    `&rand=${Date.now()}` +
                    "#page=1&#toolbar=0";
            }
        },
        onLoad() {
            const iframe = this.$refs.iframe;
            this.$nextTick(() => {
                iframe.contentWindow.PDFViewerApplication.appConfig.toolbar.container.classList.add(
                    "hidden"
                );
                this.fileLoading = false;
            });
        },
        // 查询具体合同内容
        async agreementCon(val) {
            let _this = this;
            if (val.content) {
                _this.agrCon = val;
                _this.centerDialogVisible = true;
            } else if (val.fileid) {
                _this.agrCon = val;
                this.handlePdfUrlChange(val.fileid);
                _this.centerDialogVisible = true;
            } else {
                this.$emit("all-read", true);
            }
        },
        confirmCon() {
            this.centerDialogVisible = false;
            this.index++;
            if (this.index === this.protocol.length) {
                this.$emit("all-read", true);
                return;
            }
            setTimeout(() => {
                this.autoShow();
            }, 1000);
        },
        autoShow() {
            if (this.protocol.length === 0) {
                return this.$emit("all-read", true);
            }
            this.agreementCon(this.protocol[this.index]);
        },
        getAgreement() {
            let _this = this;
            this.$util.getProtocol(this.data).then((res) => {
                _this.protocol = res;
                _this.autoShow();
            });
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.comp-agreement {
    width: 100%;
    .el-checkbox__input {
        vertical-align: top;
    }
    .el-checkbox__label {
        line-height: 40px;
        color: $text-color1;
        cursor: default;
        .agree-list {
            display: inline-block;
        }
        b {
            float: left;
            line-height: 20px;
            font-weight: normal;
            color: var(--color-text-primary);
        }
        span {
            color: $color-b;
            cursor: pointer;
            line-height: 20px;
            display: inline-block;
            float: left;
            &:after {
                content: "、";
                color: $text-color1;
            }
            &:last-child:after {
                content: "";
            }
            &:hover {
                color: var(--color-primary);
            }
        }
    }
    .el-dialog__body {
        max-height: 48vh !important;
        overflow-y: auto;
    }
}
</style>
